import { Space, Tag } from "antd"
import { ProjectType, projectTypeName } from "../../../common/constants"
import VSpace from "../../common/VSpace"
import { ReportFilterViewModel } from "../datacenterModel"
import ReportFilterDateDetails from "../ReportFilterDateDetails"

type Props = {
  filterItem: ReportFilterViewModel
}

const ManHoursReportFilterDetails = ({ filterItem }: Props) => {
  return <VSpace>
    <ReportFilterDateDetails filterItem={filterItem} />
    <Space wrap>
      {'salesPersonIds' in filterItem.filters && filterItem.filters.salesPersonIds.map((id, index) => <Tag key={index}>{id}</Tag>)}
    </Space>
    <Space>
      {'projectTypeIds' in filterItem.filters && filterItem.filters.projectTypeIds.map(projectTypeId => <Tag color='blue' key={projectTypeId}>{projectTypeName(projectTypeId as ProjectType)}</Tag>)}
    </Space>
    <Space>
      {'divisionIds' in filterItem.filters && filterItem.filters.divisionIds.map((id, index) => <Tag color='orange' key={index}>{id}</Tag>)}
    </Space>
  </VSpace>
}

export default ManHoursReportFilterDetails 